import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom, of, switchMap } from 'rxjs';

import { SessionStorageService } from '@core/services/session-storage.service';
import { AppData } from '@core/services/app-data.service';
import { config } from '@core/services/request-url.service';
import { HttpApiService } from '../http-api.service';
import { PermissionApiResponse, UserPermissions } from './permission-models';
import { StorageService } from '@core/storage-module/storage.service';

@Injectable({ providedIn: 'root' })
export class PermissionService {

    UserPermissions = signal<UserPermissions | null>(this._StorageService.getItem('UserPermissions') ?? null);

    constructor(
        private HttpApiService: HttpApiService,
        private storage: SessionStorageService,
        private route: Router,
        private readonly _StorageService: StorageService

    ) { }

    getUserPermissions$(refresh: boolean = false) {
        if (this.UserPermissions() && !refresh) {
            return of({ permissions: this.UserPermissions() })
        }
        return this.HttpApiService.post(config.auth.permission.url, {}).pipe(
            switchMap((res: PermissionApiResponse) => {

                this._StorageService.setItem('UserPermissions', res.permissions);
                this.UserPermissions.set(res.permissions);
                AppData.permissionsData.next(res);

                // has to be confirm about this
                // if (resp.firstlogin === 0) {
                //     this.route.navigate(['profile/update-password']);
                // }

                return of(res);
            })
        );

    }

    resetPermission(): void {
        this.UserPermissions.set(null);
        this._StorageService.removeItem('UserPermissions');
    }

    // async fetchPermissionsData(): Promise<any> {
    //     const storedPermissions = this.storage.getItem('permissions');
    //     if (storedPermissions) return storedPermissions;

    //     const observablePermissions = AppData.permissionsData.getValue();
    //     if (observablePermissions) return observablePermissions;

    //     return this.getUserPermissions$();
    // }

    permissions() {
        this.HttpApiService.post(config.auth.permission.url, {}).subscribe({
            next: (resp: any) => {
                // console.log("permission respponse -> ", resp)
                if (resp.statuscode == 200) {
                    AppData.permissionsData.next(resp?.permissions);
                    this.storage.setItem('permissions', resp?.permissions);
                    if (resp.firstlogin == 0) {
                        this.route.navigate(['profile/update-password']);
                    }
                } else {
                }
            },
            error: (err: any) => {
            },
        });
    };
}
